import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const ancillaryGroundServicesRatesImport = importReducer(EImportEntity.ANCILLARY_GROUND_SERVICES_RATES);
